<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.defaultDeviceCategory' : 'misc.edition.defaultDeviceCategory') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="categoryForm" *ngIf="categoryForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="categoryForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
        <app-validation-errors [control]="categoryForm.get('description')"></app-validation-errors>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancel()"
        pButton
        class="p-button-danger ml-2"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="categoryForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [disabled]="!categoryForm.valid"
        [loading]="persistingChanges"
        (onClick)="persistCategoryData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
